// CANONICAL COPY (GH #7115). src/constants/obligations/obl-capacity-management.js re-exports this file so the browser and the
// Function App share one compliance engine — one definition of "compliant". Edit here, never there.
'use strict';

module.exports = {
  id: 'obl-capacity-management',
  title: 'Review capacity management and audit log storage',
  description:
    'Confirm that resource usage is monitored and projections made to ensure required system performance continues to meet business needs, including adequate storage for audit logs so that log retention targets can be met. Capacity shall be adjusted as necessary and significant trends documented.',
  category: 'technical',
  scfIds: ['SCF-OPS-002'],
  cadence: { frequency: '1y', anchor: 'domain' },
  strategy: 'all',
  fulfilmentCriteria: [
    { type: 'document-published', description: 'Capacity management procedure is published' },
    { type: 'document-within-sla', description: 'Procedure review is not overdue' },
  ],
  domainActions: [{ type: 'approve-document', label: 'Approve Document' }],
};
